import axios, { AxiosResponse } from "axios";
import { IDocument } from "../models/document";
import { IShipDispatcher } from "../models/shipDispatcher";
import { IBooking } from "../models/booking";

export const addShipDocument = async (
    shipId: string,
    dto: IDocument,
): Promise<AxiosResponse<IShipDispatcher>> => {
    return await axios.post("/dispatcher/ship/addDocument", { shipId: shipId, document: dto });
};

export const deleteShipDocument = async (
    shipId: string,
    path: string,
): Promise<AxiosResponse<IShipDispatcher>> => {
    return await axios.delete("/dispatcher/ship/deleteDocument", {
        data: { shipId: shipId, path: path },
    });
};

export const addBookingDocument = async (
    bookingId: number,
    document: IDocument,
): Promise<AxiosResponse<IBooking>> => {
    return await axios.post("/dispatcher/booking/addBookingDocument", { bookingId, document });
};

export const deleteBookingDocument = async (
    bookingId: number,
    path: string,
): Promise<AxiosResponse<IBooking>> => {
    return await axios.delete("/dispatcher/booking/deleteBookingDocument", {
        data: { bookingId, path },
    });
};

export const getUrlForUpload = async (file: File): Promise<AxiosResponse> => {
    return await axios.post("/dispatcher/file/urlForUpload", {
        mimeType: file?.type,
        fileName: file?.name,
    });
};
export const getUrlForDownload = async (
    name: string,
    path: string,
    download: boolean,
    resourceType?: string,
    resourceId?: string,
): Promise<AxiosResponse> => {
    return await axios.post("/dispatcher/file/urlForDownload", {
        name,
        path,
        download,
        resourceType,
        resourceId,
    });
};

export const getUrlForUploadLD = async (file: File): Promise<AxiosResponse> => {
    return await axios.post("/docks/file/urlForUpload", {
        mimeType: file?.type,
        fileName: file?.name,
    });
};
export const getUrlForDownloadLD = async (
    name: string,
    path: string,
    download: boolean,
    resourceType?: string,
    resourceId?: string,
): Promise<AxiosResponse> => {
    return await axios.post("/docks/file/urlForDownload", {
        name,
        path,
        download,
        resourceType,
        resourceId,
    });
};

export const uploadFileToStorage = async (file: File, url: string) => {
    return await fetch(url, { method: "PUT", body: file });
};

export const getAllowedMimeTypes = async (): Promise<AxiosResponse<string[]>> => {
    return await axios.get("/dispatcher/file/allowedMime");
};

export const getAllowedMimeTypesLD = async (): Promise<AxiosResponse<string[]>> => {
    return await axios.get("/docks/file/allowedMime");
};
